import { Edit as EditIcon, Block as BlockIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useToggleCompanyMutation } from '../services/companies.service';
import { companiesTableColumns } from '../config/columns';
import { CompanyStatus } from '../enums/CompanyStatus';
import { IconButton, Tooltip } from '@mui/material';
import useCompanies from '../hooks/useCompanies';
import { useNavigate } from 'react-router-dom';
import { usePagination } from '@/hooks';
import { Table } from '@/components';
import { useMemo } from 'react';

interface CompanyTableProps {
  search?: string;
  onDeleteCompany?: (companyId: string, companyName: string) => void;
}

const CompanyTable = ({ search, onDeleteCompany }: CompanyTableProps) => {
  const navigate = useNavigate();

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({ initialPage: 1, initialPageSize: 10 });

  const { companies, totalItems, totalPages, isLoading } = useCompanies({
    search,
    page: currentPage,
    pageSize,
  });

  const [toggleCompany] = useToggleCompanyMutation();

  const columns = useMemo(() => companiesTableColumns, []);

  const renderActions = (rowData: Record<string, any>) => {
    const isActive = rowData.status === CompanyStatus.ACTIVE;

    return (
      <>
        <Tooltip title="Editar">
          <IconButton onClick={() => navigate(`${rowData.id}/edit`)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        
        <Tooltip title={isActive ? 'Desactivar' : 'Activar'}>
          <IconButton
            onClick={() => toggleCompany(rowData.id)}
            aria-label="Toggle status"
          >
            <BlockIcon color="action" />
          </IconButton>
        </Tooltip>

        {onDeleteCompany && (
          <Tooltip title="Eliminar">
            <IconButton
              onClick={() =>
                onDeleteCompany(String(rowData.id), String(rowData.name ?? ''))
              }
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </>
    );
  };

  return (
    <div className="w-full p-5 flex flex-col bg-white rounded-lg shadow-md gap-5">
      <Table
        data={companies}
        columns={columns}
        isLoading={isLoading}
        renderActions={renderActions}
        pagination={{
          totalItems,
          totalPages,
          currentPage,
          rowsPerPage: pageSize,
          onPageChange: handlePageChange,
          onRowsPerPageChange: handlePageSizeChange,
        }}
      />
    </div>
  );
};

export default CompanyTable;
